export default class FetchError extends Error {
    name = "FetchError";

    constructor(message, result, name) {
        super(message);

        if (name) {
            this.name = name;
        }

        const data = {};

        Object.defineProperties(
            data,
            Object.fromEntries(Object.entries(result).map(([key, value]) => [key, { value, enumerable: true }])),
        );

        Object.defineProperties(this, {
            data: {
                value: data,
                enumerable: true,
            },
        });
    }
}
